import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import { Box, Button, Card, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

import UsersGrid from './UsersGrid';

const Users = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectedType, setSelectedType] = useState('PATIENT');

    const sections = [
        { label: t('users.sections.patients'), type: 'PATIENT' },
        { label: t('users.sections.doctors'), type: 'DOCTOR' }
    ];

    const selectedSection =
        sections.find((section) => section.type === selectedType) || sections[0];

    const handleAddUser = () => {
        navigate('/users/add', {
            state: { preselectedType: selectedSection.type }
        });
    };

    return (
        <Box sx={{ minHeight: 'calc(100vh - 80px)', p: 2, bgcolor: '#F4F6F8' }}>
            <Box
                component="header"
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'stretch', sm: 'center' },
                    justifyContent: 'space-between',
                    gap: 2,
                    mb: 2
                }}
            >
                <ToggleButtonGroup
                    exclusive
                    value={selectedSection.type}
                    onChange={(_, nextType) => nextType && setSelectedType(nextType)}
                    aria-label={t('users.userTypeSelector')}
                    sx={{
                        width: { xs: '100%', sm: 'auto' },
                        height: 46,
                        p: 0.375,
                        gap: 0.5,
                        bgcolor: '#EEF2F5',
                        borderRadius: 1.5,
                        '& .MuiToggleButton-root': {
                            height: 39,
                            px: { xs: 1.5, sm: 2.5 },
                            border: 0,
                            borderRadius: '5px !important',
                            color: '#53636F',
                            fontSize: '0.82rem',
                            fontWeight: 700,
                            textTransform: 'none',
                            flex: { xs: 1, sm: 'initial' }
                        },
                        '& .MuiToggleButton-root.Mui-selected': {
                            color: '#FFFFFF',
                            bgcolor: '#1976D2',
                            boxShadow: '0 1px 3px rgba(25, 118, 210, 0.25)'
                        },
                        '& .MuiToggleButton-root.Mui-selected:hover': {
                            bgcolor: '#1565C0'
                        }
                    }}
                >
                    {sections.map((section) => (
                        <ToggleButton key={section.type} value={section.type}>
                            {section.label}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>

                {selectedSection.type === 'PATIENT' && (
                    <Button
                        variant="contained"
                        startIcon={<PersonAddAltOutlinedIcon />}
                        onClick={handleAddUser}
                        sx={{
                            minWidth: 218,
                            height: 46,
                            borderRadius: 1.5,
                            fontWeight: 700,
                            whiteSpace: 'nowrap',
                            textTransform: 'none'
                        }}
                    >
                        {t('users.addNewUser')}
                    </Button>
                )}
            </Box>

            <Card
                component="section"
                variant="outlined"
                sx={{
                    overflow: 'hidden',
                    borderColor: '#E0E5E9',
                    borderRadius: 2,
                    boxShadow: '0 1px 3px rgba(38, 50, 56, 0.08)'
                }}
            >
                <UsersGrid
                    types={[selectedSection.type]}
                    typeName={selectedSection.label}
                />
            </Card>
        </Box>
    );
};

export default Users;
